<template>
    <div class="mainCtn_1">
        <div class="topCtn">
            <span @click="$router.push('/')">首页/</span><span style="color:#000000">讲师专区</span>
        </div>

      <div class="topCtn" style="height:30px;padding-bottom: 1px;margin-bottom: 0px;">
        <div style="float:left">我负责的课程</div>
        <div class="topRadioCtn" style="float:left;margin-top: -7px;margin-left: 20px;">
          <v-radio-group
              v-model="t_courseId"
              @change="selectChange"
              row
          >
            <v-radio
                label="全部"
                color="#c49760"
                value=""
            ></v-radio>
            <v-radio
                v-for="(item,i) in courseList"
                :label=item.name
                :key="i"
                color="#c49760"
                :value=item.id
            ></v-radio>
          </v-radio-group>
        </div>
<!--        <div style="float:left">子课程</div>-->
<!--        <div style="width: 200px;height: 30px;float:left;margin-left: 20px;margin-top: -10px;">-->
<!--          <v-select-->
<!--              :items="subClassItems"-->
<!--              label=""-->
<!--              color="#c49760"-->
<!--              @change="subClassItemsChange"-->
<!--          ></v-select>-->
<!--        </div>-->
      </div>
      <div class="topCtn" style="height: 50px;clear:both;margin-bottom: 20px;">
        <div style="float:left">学习状态</div>
        <div style="width: 200px;height: 30px;float:left;margin-left: 20px;margin-top: -10px;">
          <v-select
              :items="learnStatusItems"
              label=""
              color="#c49760"
              @change="learnStatusChange"
          ></v-select>
        </div>
      </div>


        <div class="tableCtn">
            <v-data-table
                    :headers="headers"
                    :items="resultList"
                    :items-per-page="10"
                    class="elevation-1"
            >
                <template v-slot:item.learnStatus="{ item }">
                    <span v-if="item.learnStatus=='0'">
                        学习中({{item.learnLength}}/{{item.videoLength}})
                    </span>
                    <span v-if="item.learnStatus=='2'">
                        作业中
                    </span>
                    <span v-if="item.learnStatus=='1'">
                        已完成
                    </span>
                </template>
              <template v-slot:item.courseUserDto="{ item }">
                    <span @click="showMore(item)" style="color:#C49760;cursor:pointer;">
                        {{item.courseUserDto.name}}
                    </span>
              </template>
                <template v-slot:item.operate="{ item }">
                    <span v-if="item.learnStatus=='1'" @click="showHomework(item)" style="color:#C49760;cursor:pointer;">
                        查看作业
                    </span>
                    <span v-if="item.homework.score"  style="display:inline-block;color:#ffffff;cursor:pointer;margin-left: 10px;width: 60px;height: 25px;line-height: 25px;text-align: center;background-color: #bfbdbd;border-radius: 3px;">
                        已批阅
                    </span>

                </template>
            </v-data-table>
        </div>
        <!--学员详情对话框-->
        <v-row justify="center">
            <v-dialog
                    v-model="visible"
                    :width="500"
            >
                <v-card style="width: 500px;height: 430px;">
                    <v-card-title>
                        学员详情
                    </v-card-title>
                    <div style="width: 100%;height: auto">
                        <div class="studentDetail_Ctn">
                            <div class="studentDetail_item1">
                                姓名:
                            </div>
                            <div class="studentDetail_item2">
                                {{studentDetail.name}}
                            </div>
                        </div>
                        <div class="studentDetail_Ctn">
                            <div class="studentDetail_item1">
                                单位:
                            </div>
                            <div class="studentDetail_item2">
                                {{studentDetail.company}}
                            </div>
                        </div>
                        <div class="studentDetail_Ctn">
                            <div class="studentDetail_item1">
                                年龄:
                            </div>
                            <div class="studentDetail_item2">
                                {{studentDetail.age}}
                            </div>
                        </div>
                        <div class="studentDetail_Ctn">
                            <div class="studentDetail_item1">
                                性别:
                            </div>
                            <div class="studentDetail_item2">
                                {{studentDetail.sex=='0'?'男':'女'}}
                            </div>
                        </div>
                        <div class="studentDetail_Ctn">
                            <div class="studentDetail_item1">
                                手机:
                            </div>
                            <div class="studentDetail_item2">
                                {{studentDetail.phone}}
                            </div>
                        </div>
                        <div class="studentDetail_Ctn">
                            <div class="studentDetail_item1">
                                邮箱:
                            </div>
                            <div class="studentDetail_item2">
                                {{studentDetail.email}}
                            </div>
                        </div>

                    </div>
                    <v-card-actions class="justify-end">
                        <v-btn
                                text
                                @click="visible = false"
                        >关闭</v-btn>
                    </v-card-actions>
                </v-card>



            </v-dialog>
        </v-row>
        <!--查看作业-->
        <v-row justify="center" >
                <v-dialog
                        v-model="homeworkView"
                        fullscreen
                        hide-overlay
                        transition="dialog-bottom-transition"
                        style="z-index: 10000000"
                >
                    <v-card>
                        <v-toolbar
                                dark
                                color="#C49760"
                        >
                            <v-btn
                                    icon
                                    dark
                                    @click="homeworkView = false"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-toolbar-title>关闭</v-toolbar-title>
                            <v-spacer></v-spacer>

                        </v-toolbar>
                        <div class="homework">
                            <div class="homeworkText1">作业</div>
                            <!-- 大循环 -->
                            <div :class="{'question':item.type==0||item.type==1,'question1':item.type==2,'question2':item.type==3}" v-for="(item, index) in qAList" :key="index">
                                <img src="~@/assets/homework/答案正确.png" alt="" class="ansJudge" v-if="item.type!=2&&item.type!=3&&ansIsRight[index]==1">
                                <img src="~@/assets/homework/答案错误.png" alt="" class="ansJudge" v-if="item.type!=2&&item.type!=3&&ansIsRight[index]==2">
                                <div class="title">
                                    <div class="dian"></div>
                                    <div class="titleText" v-if="item.type==0">单选题 {{item.sort}}</div>
                                    <div class="titleText" v-if="item.type==1">判断题 {{item.sort-num}}</div>
                                    <div class="titleText" v-if="item.type==2">开放题</div>
                                    <div class="titleText" v-if="item.type==3">实践题</div>
                                </div>
                                <div class="quesContent">{{item.question}}</div>
                                <div v-if="['0','1'].includes(item.type)">
                                    <div class="select" v-for="(item1, index1) in item.opt" :key="index1">
                                        <img src="~@/assets/homework/选项_默认.png" alt="" class="selectImg1">
                                        <!-- <img src="~@/assets/homework/选项_选中.png" alt="" class="selectImg1" v-if="selectAns[index][index1]&&homeworkResult==false&&status==0"> -->
                                        <!-- <img src="~@/assets/homework/选项_选中置灰(作业回访).png" alt="" class="selectImg1" v-if="ansSelected[index][index1]&&status==1">
                                        <img src="~@/assets/homework/正确答案选项.png" alt="" class="selectImg2" v-if="ansRight[index][index1]"> -->
                                        <img src="~@/assets/homework/选项_选中置灰(作业回访).png" alt="" class="selectImg1" v-if="answer[index]==index1">
                                        <img src="~@/assets/homework/正确答案选项.png" alt="" class="selectImg2" v-if="item.trueAnswer==index1">
                                        <div class="selectText">{{item1}}</div>
                                    </div>
                                </div>
                                <!-- <div v-if="['0','1'].includes(item.type)">
                                    <div class="select" v-for="(item1, index1) in item.opt" :key="index1">
                                    <img src="~@/assets/homework/选项_默认.png" alt="" class="selectImg1" @click="selectWhich(index,index1)">
                                    <img src="~@/assets/homework/选项_选中.png" alt="" class="selectImg1" v-if="selectAns[index][index1]&&homeworkResult==false&&status==0">
                                    <img src="~@/assets/homework/选项_选中置灰(作业回访).png" alt="" class="selectImg1" v-if="ansSelected[index][index1]&&status==1">
                                    <img src="~@/assets/homework/正确答案选项.png" alt="" class="selectImg2" v-if="ansRight[index][index1]">
                                    <div class="selectText">{{item1}}</div>
                                    </div>
                                </div> -->
                                <!-- 开放题 -->
                                <textarea
                                        v-model="openQues"
                                        id="writeCommentId"
                                        class="writeComment"
                                        placeholder="请输入你的答案，不超过500字"
                                        @input="areaNumJudge"
                                        :disabled="true"
                                        v-if="item.type==2"
                                ></textarea>
                                <!-- <div class="selectText2" ><span v-if="item.type==2&&moreText">内容不能超过500字</span></div> -->

                                <!-- 实践题 -->
                                <div class="download" v-if="item.type==3" style="cursor: pointer;" @click="downloadFile(item.fileUrl)" @mouseover="fileDown=false" @mouseout="fileDown=true">
                                    <img src="~@/assets/homework/下载_默认.png" alt="" class="downloadImg" v-if="fileDown" >
                                    <img src="~@/assets/homework/下载_hover.png" alt="" class="downloadImg" v-if="!fileDown" >
                                    <div :class="fileDown == true ? 'selectText3' : 'selectText3-s'">下载样例数据.zip</div>
                                </div>
                                <img src="~@/assets/homework/样例数据缩略图.jpg" alt="" class="shijianImg" v-if="item.type==3">
                                <div class="download" v-if="item.type==3" style="cursor: pointer;margin-top: -110px;" @click="downloadFile(item.pictureUrl)" @mouseover="hoverControl()" @mouseout="fileDown1=true">
                                    <!-- <img src="~@/assets/homework/上传_默认.png" alt="" class="downloadImg" v-if="fileDown1" >
                                    <img src="~@/assets/homework/上传_hover.png" alt="" class="downloadImg" v-if="!fileDown1" > -->
                                    <img src="~@/assets/homework/下载_默认.png" alt="" class="downloadImg" v-if="fileDown" >
                                    <img src="~@/assets/homework/下载_hover.png" alt="" class="downloadImg" v-if="!fileDown" >
                                    <div :class="fileDown1 == true ? 'selectText3' : 'selectText3-s'" style="width: 500px;" id="selectText3Id">{{fileName}}</div>
                                    <!-- <input
                                    type="file"
                                    class="fileUpload"
                                    name="file"
                                    id="file"
                                    @input="fileChange"
                                    /> -->
                                </div>
                                <div style="color: #C49760;margin-left: 69px;" v-if="['2','3'].includes(item.type)">
                                    <div style="font-weight:bold;font-size:20px;margin-top:20px;">讲师评分</div>
                                    <div class="scoreBtnsDiv" @click="scoreBtnsClick($event,item)">
                                        <span :class="homeworkScore=='1' ? 'scoreBtn scoreBtnSelected':'scoreBtn'">1</span>
                                        <span :class="homeworkScore=='2' ? 'scoreBtn scoreBtnSelected':'scoreBtn'">2</span>
                                        <span :class="homeworkScore=='3' ? 'scoreBtn scoreBtnSelected':'scoreBtn'">3</span>
                                        <span :class="homeworkScore=='4' ? 'scoreBtn scoreBtnSelected':'scoreBtn'">4</span>
                                        <span :class="homeworkScore=='5' ? 'scoreBtn scoreBtnSelected':'scoreBtn'">5</span>
                                        <span :class="homeworkScore=='6' ? 'scoreBtn scoreBtnSelected':'scoreBtn'">6</span>
                                        <span :class="homeworkScore=='7' ? 'scoreBtn scoreBtnSelected':'scoreBtn'">7</span>
                                        <span :class="homeworkScore=='8' ? 'scoreBtn scoreBtnSelected':'scoreBtn'">8</span>
                                        <span :class="homeworkScore=='9' ? 'scoreBtn scoreBtnSelected':'scoreBtn'">9</span>
                                        <span :class="homeworkScore=='10' ? 'scoreBtn scoreBtnSelected':'scoreBtn'">10</span>
                                    </div>
                                </div>
                            </div>
                            <!-- 提交作业按钮 -->
                            <!-- <div class="inputHomework" @click="homeworkSubmit()" v-if="!homeworkResult">交作业</div>
                            <div class="inputHomework-s" v-if="homeworkResult">已交作业</div> -->
                        </div>

                    </v-card>



                </v-dialog>
            </v-row>

    </div>


</template>

<script>
    export default {
        name: "teachingManage",
        data(){
            return{
               courseList:[],
               selectedRadio:'',
                headers: [
                    {
                        text: '课程名称',
                        align: 'start',
                        sortable: false,
                        value: 'videoName',
                    },
                    { text: '学生姓名', value: 'courseUserDto',sortable: false, },
                    { text: '最近学习时间', value: 'lastLearnTime',sortable: false, },
                    { text: '学习状态', value: 'learnStatus',sortable: true, },
                    { text: '操作', value: 'operate',sortable: false, },
                ],
                resultList:[],
                visible: false,
                homeworkView:false,
                studentDetail:{},
                // 作业中的参数
                // homeworkId:"",
                name:"WebGIS后端开发技术：第1课时作业",
                qAList:[],
                //单选题数量
                num:0,
                //单选和判断题数量
                numTwo:0,
                list:["A. NIR/R","B. (NIR-R)/G","C. (R-G)/(R+G)","D. (NIR-R)/(NIR+R)"],
                //用户选择
                selectAns:[[]],
                //正确答案
                ansRight:[[]],
                //正确错误左上角标志
                ansIsRight:[],
                //置灰选择
                ansSelected:[[]],
                openQues:"",
                moreText:false,
                fileDown:true,
                fileDown1:true,
                fileName:"下载学员的结果",
                fileUp:[],
                shadow:0,
                homeworkResult:false,
                status:0,
                answer:[],
                //新添加
                homeworkScore:"",
                t_learnStatus:'',
                t_courseId:'',
                t_videoId:'',
                t_learnId:'',
              learnStatusItems:[{
                text:"全部",
                value: "",
              },{
                text:"学习中",
                value: "0",
              },{
                text:"已完成",
                value: "1",
              },{
                text:"作业中",
                value: "2",
              }],
                subClassItems:[{
                text:"全部",
                value: "",
              },
                  {
                    text:"全部1",
                    value: "1",
                  }],

            }
        },
        methods:{
          //学习状态改变
          learnStatusChange(data){
            this.t_learnStatus=data;
            this.getLearnList();
          },
          //子课程筛选改变
          subClassItemsChange(data){
            console.log(data)
            this.t_videoId=data;
            this.getLearnList();

          },
          //获取子课程列表
          getSubClassList(id){
            this.axios
                .get("/learn_back/course/courseLearn/queryTeacherAllVideos/"+id, "",{
                  headers: {
                    Authorization: "Bearer " + this.getKey(),
                  }
                }).then((response) => {
              console.log('返回子课程')
              console.log(response)
            })
          },
          //获取讲师课程列表
          getTeacherClass(){
            this.axios
                .get("/learn_back/course/courseLearn/queryAllTeacherCourses", "",{
                  headers: {
                    Authorization: "Bearer " + this.getKey(),
                  }
                }).then((response) => {

              this.courseList=response.data.data;
              console.log('返回讲师课程')
              console.log(this.courseList)
            })
            this.getSubClassList("0")
          },
          //大课程筛选修改
          selectChange:function (data) {
            console.log(data)
            this.getLearnList();
            if(this.t_courseId==""){
              this.getSubClassList("0")
            }
            else{
              this.getSubClassList(this.t_courseId)
            }
          },
            getKey() {
                return localStorage.getItem("token");
            },
            showMore:function (item) {
                console.log(item)
                this.studentDetail=item.courseUserDto
                this.visible = true;
            },
            showHomework:function (record) {
                this.num=0;
                this.print(record)
              this.t_learnId=record.homework.learnId;
                if (record.homework) {
                    // this.qAList = JSON.parse(JSON.stringify(record.homework.qaList));
                    this.qAList = record.homework.qAList
                    console.log(this.qAList ,"qAList");
                    this.answer=JSON.parse(JSON.stringify(record.homework.answer));
                    this.homeworkScore=""
                    this.homeworkScore=record.homework.score;
                    console.log("score:",this.homeworkScore)
                    // console.log(resData.data.answer)
                    this.numTwo=this.qAList.length-2
                    let j =0
                    this.qAList.forEach((item,index) => {
                        if (['0','1'].includes(item.type)) {
                            if (item.opt) {
                                if (!(item.opt instanceof Object)) {
                                    item.opt=JSON.parse(item.opt)
                                }
                            }
                            item.trueAnswer--;
                            // this.qAList[index].trueAnswer--;
                            this.answer[index]--;
                            this.ansIsRight[index]=(item.trueAnswer==this.answer[index])?1:2;
                        }
                        if (['2'].includes(item.type)) {
                            this.openQues=this.answer[index]
                        }
                        this.selectAns[j]=new Array()
                        this.ansRight[j]=new Array()
                        this.ansSelected[j]=new Array()

                        for(let i=0;i<6;i++){
                            this.selectAns[j][i]=false
                            this.ansRight[j][i]=false
                            this.ansSelected[j][i]=false

                        }
                        if(item.type==0){
                            this.num++
                        }
                        j++
                    })
                    if(this.answer!=''&&this.answer!=null){
                        this.status=1
                        // this.workSubmitted()
                    }
                    this.listVisible = true;
                }
                this.homeworkView=true;
            },
            scoreBtnsClick(e,item){
                if (e.target.classList.contains('scoreBtn')) {
                    e.currentTarget.childNodes.forEach(n=>{
                        n.classList.remove('scoreBtnSelected')
                    })
                  this.homeworkScore=e.target.innerText;
                    let param={
                        "id":"",
                        "score":""
                    }
                    param.id=this.t_learnId;
                    param.score=e.target.innerText;
                    console.log(param)
                    this.axios
                        .post("/learn_back/course/courseLearn/scoreHomework", param,{
                            headers: {
                                Authorization: "Bearer " + this.getKey(),
                            }
                        }).then((response) => {
                        console.log('查看课程')
                        console.log(response)
                        if(response.status==200){
                           alert("批阅成功");
                          this.getLearnList();
                        }
                    })
                }
            },
            getLearnList:function () {
                let that=this;
                let param = new FormData();
                param.append('learnStatus',this.t_learnStatus)
                param.append('courseId',this.t_courseId)
                param.append('videoId',this.t_videoId)
                param.append('pageNo', 1);
                param.append('pageSize',100);
                this.axios
                    .get("/learn_back/course/courseLearn/listLearnRecords?courseId="+this.t_courseId+"&videoId="+this.t_videoId+"&learnStatus="+this.t_learnStatus+"&correctStatus=&pageNo=1&pageSize=100",{
                        headers: {
                            Authorization: "Bearer " + this.getKey(),
                        }
                    }).then((response) => {
                    console.log('查看课程')
                    console.log(response.data.data.records)
                    if(response.status==200){
                        that.resultList=response.data.data.records;
                    }
                })
            },
            areaNumJudge(){
                let a = this.openQues
                if(a!=undefined&&a!=""&&a!=null){
                    let contentDes2 = a.length;
                    let writeCommentId = document.getElementById("writeCommentId");
                    if (contentDes2 < 1 || contentDes2 >500) {
                        writeCommentId.style.border = "1px solid #FF4040";
                        this.moreText=true
                    } else {
                        writeCommentId.style.border = "1px solid rgba(0,0,0,0.2)";
                        this.moreText=false
                    }
                }
            },



        },
        mounted(){
            // this.resultList=this.resultTemp.result.records;
            this.getLearnList();
            this.getTeacherClass();


        }
    }
</script>

<style scoped>
      .topRadioCtn{
        width: auto;
        height: 50px;
        line-height: 50px;
        padding-right: 20px;
      }
    .topCtn{
        margin-left: auto;
        margin-right: auto;
        width: 1280px;
        height: 50px;
        line-height: 50px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #979797;
    }
    .studentDetail_Ctn{
        width: 100%;
        height: 50px;
        font-size: 15px;
    }
    .studentDetail_item1 {
        width: 150px;
        height: 50px;
        line-height: 50px;
        text-align: right;
        float:left;
    }
    .studentDetail_item2 {
        width: 350px;
        height: 50px;
        padding-left: 20px;
        line-height: 50px;
        text-align: left;
        float:left;
    }
    .tableCtn{
      padding-top: 1px;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 80px;
        width: 1280px;
        min-height: 700px;
        font-size: 16px;
    }
    .mainCtn_1{
        padding-top: 160px;
        width: 100%;
        height: 100%;
        background: #F5F5F6;
        border-radius: 16px;
    }
    .top{
        position: relative;
        width: 100%;
        height: 76px;
        background: #FFFFFF;
        border-bottom: 1px solid rgba(0,0,0,0.1);
    }
    .topContent{
        position: absolute;
        width: 1280px;
        height: 76px;
        left: calc(50% - 640px);
    }
    .topText1{
        position: absolute;
        left: 0;
        width:80px;
        height: 76px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 500;
        color: #3A3A3A;
        line-height: 76px;
        cursor: pointer;
    }
    .topText2{
        position: absolute;
        width: 500px;
        left: calc(50% - 250px);
        height: 76px;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #3A3A3A;
        line-height:76px;
        text-align: center;
    }
    .topText3{
        position: absolute;
        top: 18px;
        right: 0;
        width: 112px;
        height: 40px;
        background: #C49760;
        border-radius: 20px;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height:40px;
        text-align: center;
        cursor: pointer;
    }
    .homework{
        /* margin-top: 16px; */
        width: 100%;
        height:auto;
        padding-bottom: 10px;
    }
    .homeworkText1{
        margin-top: 54px;
        margin-bottom: 53px;
        margin-left: calc(50% - 30px);
        width: 60px;
        height: 42px;
        font-size: 30px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #3A3A3A;
        line-height: 42px;
        text-align: center;
    }
    .question{
        margin-left: calc(50% - 640px);
        margin-bottom: 20px;
        padding-bottom:34px;
        width: 1280px;
        height: auto;
        background: linear-gradient(135deg, #F7F7F7 0%, #FCFCFC 100%);
        border-radius: 16px;
        overflow: hidden;
    }
    .question1{
        margin-left: calc(50% - 640px);
        margin-bottom: 20px;
        padding-bottom: 34px;
        width: 1280px;
        height: auto;
        background-image:url(~@/assets/homework/开放题背景.png);
        border-radius: 16px;
        overflow: hidden;
    }
    .question2{
        margin-left: calc(50% - 640px);
        margin-bottom: 20px;
        padding-bottom: 34px;
        width: 1280px;
        height: auto;
        background-image:url(~@/assets/homework/实践题背景.png);

        border-radius: 16px;
        overflow: hidden;
    }
    .ansJudge{
        float: left;
        width: 75px;
        height: 75px;
        margin-top: 0;
        margin-left: 0;
    }
    .title{
        position: relative;
        width: auto;
        height: 26px;
        margin-top: 30px;
        margin-left: 50%;
        transform: translate(-6%, 0);
    }
    .dian{
        position: absolute;
        top: 7px;
        width: 9px;
        height: 9px;
        background: #5A5A5A;
        border-radius: 50%;
    }
    .titleText{
        position: absolute;
        left: 19px;
        width: auto;
        height: 26px;
        font-size: 20px;
        font-family: Tensentype-ZhiHeiJ-W2, Tensentype-ZhiHeiJ;
        font-weight: normal;
        color: #5A5A5A;
        line-height: 26px;
    }
    .quesContent{
        margin-top: 35px;
        margin-left: 69px;
        margin-bottom: 45px;
        width: 1142px;
        height: auto;
        font-size: 18px;
        font-family: Tensentype-ZhiHeiJ-W2, Tensentype-ZhiHeiJ;
        font-weight: normal;
        color: #5A5A5A;
        line-height: 26px;

    }
    .select{
        position: relative;
        margin-bottom: 25px;
        margin-left: 69px;
        width: 1142px;
        height: auto;
        font-size: 18px;
        font-family: Tensentype-ZhiHeiJ-W2, Tensentype-ZhiHeiJ;
        font-weight: normal;
        color: #5A5A5A;
        line-height: 26px;
    }
    .selectImg1{
        position: absolute;
        top: 2px;
        left: 0;
        width: 20px;
        height: 20px;
        cursor: pointer;
    }
    .selectImg2{
        position: absolute;
        top: -6px;
        left: -8px;
        width: 36px;
        height: 36px;
        cursor: pointer;
    }
    .selectText{
        margin-left: 30px;
        width: auto;
        font-size: 18px;
        font-family: Tensentype-ZhiHeiJ-W2, Tensentype-ZhiHeiJ;
        font-weight: normal;
        color: #5A5A5A;
        line-height: 26px;
    }
    .writeComment{
        margin-left: 69px;
        width: 1142px;
        height: 239px;
        background:transparent;
        border-radius: 8px;
        border: 1px solid rgba(0,0,0,0.2);
        outline: none;
        padding-top: 16px;
        padding-left: 22px;
        padding-right: 22px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight:500;
        color: #000000;
        line-height: 20px;
        resize: none;
    }
    .selectText2{
        margin-top: 10px;
        margin-left:69px;
        width: 106px;
        height: 24px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FF4040;
        line-height: 24px;
    }
    .download{
        position: relative;
        float: left;
        margin-top: 30px;
        margin-left: 71px;
        width: 160px;
        height: 20px;
        /* background-color: pink; */
    }
    .downloadImg{
        position: absolute;
        width: 20px;
        height: 20px;
        top: 0;
        left: 0;
    }
    .fileUpload{
        position: absolute;
        top: 0;left:0;
        width: 136px;
        height:20px;
        background-color: pink;
        opacity: 0;
        cursor: pointer;
        box-sizing: border-box;
        padding: 20px;
        z-index: 1;
    }
    .fileNow{
        position: absolute;
        top: 0;
        left: 150px;
        width: 500px;
        height: 20px;
        font-size: 17px;
        font-family: Tensentype-ZhiHeiJ-W2, Tensentype-ZhiHeiJ;
        font-weight: normal;
        color: #5A5A5A;
        line-height: 20px;
        /* background-color: pink; */
    }
    .selectText3{
        position: absolute;
        top: 0;left: 26px;
        width: 136px;
        height: 20px;
        font-size: 18px;
        font-family: Tensentype-ZhiHeiJ-W2, Tensentype-ZhiHeiJ;
        font-weight: normal;
        color: #5A5A5A;
        line-height: 20px;
    }
    .selectText3-s{
        position: absolute;
        top: 0;left: 26px;
        width: 136px;
        height: 20px;
        font-size: 18px;
        font-family: Tensentype-ZhiHeiJ-W2, Tensentype-ZhiHeiJ;
        font-weight: normal;
        color: #C49760;
        line-height: 20px;
    }
    .shijianImg{
        /* float: left; */
        margin-top: -20px;
        width: 380px;
        height: 280px;
        margin-left: 576px;
        margin-bottom: 20px;
    }
    .inputHomework{
        margin-top: 101px;
        margin-bottom: 100px;
        margin-left: calc(50% - 75px);
        width: 150px;
        height: 54px;
        background: rgba(255,255,255,0.25);
        border-radius: 27px;
        border: 1px solid #C49760;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight:500;
        color: #C49760;
        line-height: 54px;
        text-align: center;
        cursor: pointer;
    }
    .inputHomework:hover{
        background: #C49760;
        border-radius: 27px;
        border: 1px solid #C49760;

        color: #FFFFFF;
    }
    .inputHomework-s{
        margin-top: 101px;
        margin-bottom: 100px;
        margin-left: calc(50% - 75px);
        width: 150px;
        height: 54px;
        background: rgba(255,255,255,0.25);
        border-radius: 27px;
        border: 1px solid #CCCCCC;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight:500;
        color: #CCCCCC;
        line-height: 54px;
        text-align: center;
    }
    .shadow{
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;left: 0;
        background: rgba(0,0,0,0.5);
        z-index: 10000;
    }
    .tip{
        position: absolute;
        top: calc(50% - 200px);
        left: calc(50% - 400px);
        width: 800px;
        height: 400px;
        background: #FFFFFF;
        border-radius: 16px;
    }
    .tipText1{
        position: absolute;
        top: 46px;
        left: calc(50% - 20px);
        width: 40px;
        height: 28px;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #3A3A3A;
        line-height: 28px;
        text-align: center;
    }
    .tipText2{
        position: absolute;
        top: 143px;
        left: calc(50% - 250px);
        width: 500px;
        height: 36px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #3A3A3A;
        line-height: 36px;
        text-align: center;
    }
    .tipText3{
        position: absolute;
        top: 290px;
        left: calc(50% - 56px);
        width: 112px;
        height: 44px;
        background: #C49760;
        border-radius: 22px;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 44px;
        text-align: center;
        cursor: pointer;
    }

    .scoreBtnsDiv{
        display: flex;
        margin-top:20px;
    }
    .scoreBtn{
        border: 2px solid #C49760;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 20px;
        cursor: pointer;
    }
    .scoreBtnSelected{
        color: white;
        background-color: #C49760;
    }

</style>